import { useHistory, useLocation } from "react-router-dom";
import CloseIcon from "../../assets/svg/CloseIcon";
import Button from "../organism/Button";
import CustomText from "./CustomText";
import "./Popup.css";
import { useToggleReleasePopupMutation } from "../../services/utils/custom hooks/useReleasePopupToggle";

const NewReleasePopup = ({ onClose, startTour, isReleasePopupButtonEnabled }: any) => {
  const history = useHistory()
  const location = useLocation()
  function openTour() {
    if(location?.pathname !== "/access/dashboard") {
      history.push("/access/dashboard");
    }
    startTour();
    onClose()
  }
  const { mutation } = useToggleReleasePopupMutation();
  const handleToggle = (enabled: boolean) => {
    mutation.mutate({ isReleasePopupButtonEnabled: enabled });
  };

  const closePopup = () => {
    if(isReleasePopupButtonEnabled) {
      handleToggle(false);
    }
    onClose();
  };
  
  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <div className="popup-header">
          <img
            src={require("../../assets/images/NewReleasePopupImage.png")}
            alt="Rocket"
            className="popup-icon"
          />
          <button className="popup-close" onClick={closePopup}>
            <CloseIcon />
          </button>
        </div>
        <CustomText
          text="New Release"
          fontWeight="font-medium"
          className="popup-title "
        />
          <CustomText
          text="We have added new features and enhancements for a smoother user experience. "
          fontWeight="font-normal"
          className="popup-description"
        />
        <hr />
        <ul className="popup-list">
        <li>
            <CustomText
              text="1. General maintenance and updates"
              fontWeight="font-normal"
              className="popup-list-item"
            />
          </li>
          <li>
            <CustomText
              text="2. Performance and stability enhancements"
              fontWeight="font-normal"
              className="popup-list-item"
            />
          </li>
          <li>
            <CustomText
              text="3. Improvements to user interface and design"
              fontWeight="font-normal"
              className="popup-list-item"
            />
          </li>
        </ul>

        <hr />
        <Button
          buttonTheme="primary"
          textInformation={{
            text: `EXPLORE NOW`,
            fontWeight: "font-semibold",
          }}
          onClick={openTour}
          className="popup-button"
        />
      </div>
    </div>
  );
};

export default NewReleasePopup;
